var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"school-district-estimator h-100"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col"},[_c('tax-lookup',{attrs:{"lookup-type":"district","disclaimer":_vm.disclaimer,"note":_vm.note,"headline":"School District Estimator"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }